import { call, put } from 'redux-saga/effects'
import api from './../../utils/api'
import actions from './actions'

const getFeatures = () => call(api.getFeatures)

function* fetchFeatures() {
  let features = []
  try {
    features = yield getFeatures()
  } finally {
    yield put({ type: actions.setFeatures, features })
  }
}

export default fetchFeatures



// WEBPACK FOOTER //
// ./src/store/features/saga.js